import { Box, Flex, Text, Heading } from '@moonpig/launchpad-components'
import { styled } from '@moonpig/launchpad-utils'
import React, { FC } from 'react'
import { system as s } from '@moonpig/launchpad-system'
import { InputForm, CloseButton, BannerImage } from './components'

const StyledRangeFilterEntryPointBanner = styled(Box)`
  height: 100%;
  position: relative;

  ${s({
    px: { xs: 4, md: 3, lg: 5, xxl: 10 },
    pb: { xs: 4, md: 3, lg: 5, xxl: 10 },
  })}
`

const StyledBannerLayout = styled(Flex)`
  ${s({
    flexDirection: { xs: 'column', md: 'row' },
    width: '100%',
    height: '100%',
    boxShadow: 2,
    borderRadius: 4,
    bgcolor: 'colorBackground07',
  })}
`

const StyledBannerContent = styled(Flex)`
  flex-direction: column;
  align-items: start;
  justify-content: center;
  width: 100%;
  height: 100%;

  ${s({
    p: { xs: 6, xxl: 8 },
    gap: 16,
  })}
`

const StyledHeading = styled(Heading)`
  ${s({
    typography: {
      xs: 'typeMobileDisplay04',
      sm: 'typeMobileDisplay03',
      md: 'typeDesktopDisplay04',
      lg: 'typeDesktopDisplay03',
    },
    color: 'colorTextInverted',
    textAlign: 'left',
    alignSelf: 'top',
    m: 0,
  })}
`

const StyledBannerDescriptionText = styled(Text)`
  ${s({
    typography: { xs: 'typeBodyText', lg: 'typeBodyLead' },
    color: 'colorTextInverted',
    textAlign: 'left',
    alignSelf: 'top',
    mb: 4,
  })}
`

type RangeFilterEntryPointBannerProps = {
  title: string
  description: string
  images: {
    xs: string
    md: string
    description: string
  }
  ctaTitle: string
  filterId: string
}

export const RangeFilterEntryPointBanner: FC<
  RangeFilterEntryPointBannerProps
> = ({ title, description, images, ctaTitle, filterId }) => {
  return (
    <StyledRangeFilterEntryPointBanner>
      <CloseButton />
      <StyledBannerLayout>
        <BannerImage images={images} />
        <StyledBannerContent width="50%">
          <Flex flexDirection="column" gap={{ xs: 0, md: 8 }}>
            <StyledHeading as="h3">{title}</StyledHeading>
            <StyledBannerDescriptionText as="p">
              {description}
            </StyledBannerDescriptionText>
          </Flex>
          <InputForm filterId={filterId} ctaTitle={ctaTitle} />
        </StyledBannerContent>
      </StyledBannerLayout>
    </StyledRangeFilterEntryPointBanner>
  )
}
